var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcPoorVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dc_poor-visibility") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.06,1.19A36.12,36.12,0,1,0,73.19,37.31,36.16,36.16,0,0,0,37.06,1.19Zm0,70.24A34.12,34.12,0,1,1,71.19,37.31,34.16,34.16,0,0,1,37.06,71.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.45,37a53.53,53.53,0,0,0-6.07-4.5,54.44,54.44,0,0,0-7.29-3.93.4.4,0,0,0-.52.11C49.77,30.5,48,32.3,46.15,34.1a.54.54,0,0,0-.16.61A9.34,9.34,0,0,1,34.35,46.29a.43.43,0,0,0-.52.13c-.29.31-.6.6-.9.9l-1.64,1.6.05.15c1.45.14,2.9.34,4.36.4a34.17,34.17,0,0,0,11.87-1.63,50.26,50.26,0,0,0,14.59-7.51c1.27-.92,2.47-1.93,3.74-2.92Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.84,42.22a6.69,6.69,0,0,0,2-5.71l-7.63,7.63A6.67,6.67,0,0,0,41.84,42.22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6,19.29a2.7,2.7,0,0,1-.22.33l-6.27,6.27a.56.56,0,0,1-.62.18,34.41,34.41,0,0,0-5.72-.81,35.53,35.53,0,0,0-14.43,2.39,52,52,0,0,0-13.66,7.71c-.82.63-1.61,1.3-2.45,2A53.85,53.85,0,0,0,24.06,47l-5.67,5.66,3.5,3.53L55.17,22.86ZM39.93,31c0,.06-.23,0-.34,0a6.83,6.83,0,0,0-8.91,8.76.53.53,0,0,1-.15.69c-.51.49-1,1-1.53,1.56A9.3,9.3,0,0,1,41.69,29.31C41.1,29.9,40.53,30.48,39.93,31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcPoorVisibility);
export default __webpack_public_path__ + "static/media/dc_poor-visibility.9c086f7fc3dbcaa948e553c7b354c469.svg";
export { ForwardRef as ReactComponent };